(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["advance-pdp-bottom"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initAPB(root) {
      if (!root || root.dataset.apbInit === '1') return;
      root.dataset.apbInit = '1';

      /* ---- 0. CTA buttons -> smooth scroll to top of the PDP (#hero) ---- */
      root.querySelectorAll('a[href="#hero"]').forEach(function (link) {
        link.addEventListener('click', function (e) {
          var target = document.getElementById('hero')
                     || document.querySelector('.fblp-container')
                     || document.getElementById('pdpMain');
          if (target) {
            e.preventDefault();
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          } else {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }
        });
      });

      /* ---- 1. Video carousel (scroll + arrows + dots) ---- */
      (function () {
        var carousel = root.querySelector('[data-apb-carousel]');
        var dotsWrap = root.querySelector('[data-apb-dots]');
        if (!carousel) return;
        var cards = carousel.querySelectorAll('.community-card');
        if (!cards.length) return;
        var index = 0, dots = [];
        var gap = 12;
        function cardW() { return cards[0].offsetWidth + gap; }
        function update() { dots.forEach(function (d, i) { d.classList.toggle('active', i === index); }); }
        function goTo(i) { index = Math.max(0, Math.min(i, cards.length - 1)); carousel.scrollTo({ left: index * cardW(), behavior: 'smooth' }); update(); }
        if (dotsWrap) {
          cards.forEach(function (_, i) {
            var d = document.createElement('div');
            d.className = 'ir-dot' + (i === 0 ? ' active' : '');
            d.addEventListener('click', function () { goTo(i); });
            dotsWrap.appendChild(d); dots.push(d);
          });
        }
        var prev = root.querySelector('[data-apb-prev]');
        var next = root.querySelector('[data-apb-next]');
        if (prev) prev.addEventListener('click', function () { goTo(index - 1); });
        if (next) next.addEventListener('click', function () { goTo(index + 1); });
        carousel.addEventListener('scroll', function () {
          var i = Math.round(carousel.scrollLeft / cardW());
          if (i !== index) { index = i; update(); }
        });
      })();

      /* ---- 2. Reviews 3D coverflow ---- */
      (function () {
        var track = root.querySelector('[data-apb-rcf]');
        if (!track) return;
        var cards = track.querySelectorAll('.reviews-cf__card');
        if (!cards.length) return;
        var TOTAL = cards.length, active = Math.min(2, TOTAL - 1), GAP = 270, AUTO = 3500, timer = null;
        var S = [
          { tx:-2, tz:-280, ry:46,  sc:0.63, op:0.22 },
          { tx:-1, tz:-140, ry:28,  sc:0.80, op:0.58 },
          { tx:0,  tz:0,    ry:0,   sc:1.00, op:1.00 },
          { tx:1,  tz:-140, ry:-28, sc:0.80, op:0.58 },
          { tx:2,  tz:-280, ry:-46, sc:0.63, op:0.22 }
        ];
        function render(cur) {
          cards.forEach(function (card, i) {
            var rel = i - cur;
            if (rel > 2) rel -= TOTAL; else if (rel < -2) rel += TOTAL;
            if (card._rel !== undefined && Math.abs(rel - card._rel) > 2) { card.style.transition = 'none'; void card.offsetWidth; }
            else { card.style.transition = ''; }
            card._rel = rel;
            var s = S[rel + 2];
            if (!s) { card.style.opacity = 0; card.style.pointerEvents = 'none'; return; }
            card.style.transform = 'translateX(' + (s.tx * GAP) + 'px) translateZ(' + s.tz + 'px) rotateY(' + s.ry + 'deg) scale(' + s.sc + ')';
            card.style.opacity = s.op;
            card.style.zIndex = 100 - Math.abs(rel) * 2;
            card.style.pointerEvents = 'auto';
            card.classList.toggle('is-active', rel === 0);
          });
        }
        function goTo(i) { active = (i % TOTAL + TOTAL) % TOTAL; render(active); }
        function nextSlide() { goTo(active + 1); }
        function startAuto() { stopAuto(); timer = setInterval(nextSlide, AUTO); }
        function stopAuto() { if (timer) { clearInterval(timer); timer = null; } }
        var prevBtn = root.querySelector('.reviews-cf__arrow--prev');
        var nextBtn = root.querySelector('.reviews-cf__arrow--next');
        if (prevBtn) prevBtn.addEventListener('click', function () { goTo(active - 1); startAuto(); });
        if (nextBtn) nextBtn.addEventListener('click', function () { goTo(active + 1); startAuto(); });
        cards.forEach(function (c, i) { c.addEventListener('click', function () { goTo(i); startAuto(); }); });
        var box = track.closest('.reviews-cf__carousel') || track;
        box.addEventListener('mouseenter', stopAuto);
        box.addEventListener('mouseleave', startAuto);
        render(active); startAuto();
      })();

      /* ---- 3. FAQ accordion ---- */
      root.querySelectorAll('[data-apb-faq]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var item = btn.parentElement;
          root.querySelectorAll('.rj-faq-item').forEach(function (i) { if (i !== item) i.classList.remove('active'); });
          item.classList.toggle('active');
        });
      });
    }

    function boot() {
      document.querySelectorAll('.apb').forEach(initAPB);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    /* Re-init when section is re-rendered in the theme editor */
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('.apb'); if (el) initAPB(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aplus-content"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__aplusScrollTopInit) return;
    window.__aplusScrollTopInit = true;

    document.addEventListener('click', function (event) {
      var link = event.target.closest('[data-aplus-scroll-top]');
      if (!link) return;

      event.preventDefault();
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, left: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["best-deals-live-tv"] && !Shopify.designMode) return;
  try {
    
  function initBestDealsCarousel() {
    var carousels = document.querySelectorAll('.best-deals-live-tv__carousel');
    
    carousels.forEach(function(carousel) {
      if (carousel.dataset.bestDealsInit) return;
      carousel.dataset.bestDealsInit = 'true';

      var sectionId = carousel.id.replace('best-deals-carousel-', '');
      var buttons = document.querySelectorAll('[data-best-deals-carousel-button="' + sectionId + '"]');

      function getScrollAmount() {
        var card = carousel.querySelector('.best-deals-live-tv__card');
        if (!card) return carousel.clientWidth / 2;
        
        var style = window.getComputedStyle(carousel);
        var gap = parseInt(style.gap) || 24;
        return card.offsetWidth + gap;
      }

      buttons.forEach(function(button) {
        button.addEventListener('click', function(e) {
          e.preventDefault();
          var direction = button.dataset.direction === 'right' ? 1 : -1;
          var scrollAmount = getScrollAmount();
          
          carousel.scrollBy({
            left: direction * scrollAmount,
            behavior: 'smooth'
          });
        });
      });
    });
  }

  // Initialize on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBestDealsCarousel);
  } else {
    initBestDealsCarousel();
  }

  // Re-initialize when section is loaded in theme editor
  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.classList.contains('best-deals-live-tv')) {
      initBestDealsCarousel();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lgd-top-section"] && !Shopify.designMode) return;
  try {
    
function initHeroBanners() {
    const heroes = document.querySelectorAll(".spy-plp-conatiner .hero");
    heroes.forEach(hero => {
        if (hero.dataset.sliderInit === "1") return;

        const cards = hero.closest('.spy-plp-conatiner').querySelectorAll(".product-card");
        if (!cards.length) return;

        hero.dataset.sliderInit = "1";
        const sectionId = hero.dataset.sectionId;

        const allDesktopBgs = [];
        const allMobileBgs = [];
        cards.forEach(card => {
            if (card.dataset.bgDesktop) allDesktopBgs.push(card.dataset.bgDesktop);
            if (card.dataset.bgMobile) allMobileBgs.push(card.dataset.bgMobile);
        });

        const SLIDE_COUNT = cards.length;
        const INTERVAL_MS = parseInt(hero.dataset.rotatorSpeed) || 3000;
        let index = 0;
        let timer = null;

        const getPreloadImages = (mainOnly) => {
            const isMobile = window.innerWidth <= 991;
            if (mainOnly) {
                return isMobile ? allMobileBgs : allDesktopBgs;
            }
            return isMobile ? allDesktopBgs : allMobileBgs;
        };

        function preload(urls) {
            return Promise.all(urls.map(src => {
                const img = new Image();
                img.src = src;
                return img.decode ? img.decode().catch(() => {})
                    : new Promise(res => { img.onload = img.onerror = res; });
            }));
        }

        function render() {
            const activeCard = cards[index % cards.length];
            const isMobile = window.innerWidth <= 991;
            if (window.innerWidth >= 768) {
              const customBg = isMobile ? activeCard.dataset.bgMobile : activeCard.dataset.bgDesktop;
              hero.style.backgroundImage = customBg ? `url("${customBg}")` : '';
            } else {
              hero.style.backgroundImage = '';
            }
            cards.forEach((card, i) => card.classList.toggle("active", i === index));
        }

        function next() {
            index = (index + 1) % SLIDE_COUNT;
            render();
        }

        function start() {
            if (timer) return;
            render();
            timer = setInterval(next, INTERVAL_MS);
        }

        preload(getPreloadImages(true)).then(start);
        preload(getPreloadImages(false));

        const onResize = () => render();
        window.addEventListener("resize", onResize);

        cards.forEach(function(card) {
            card.addEventListener('click', function() {
                const scroll_to_bottom = card.dataset.scrollToBottom === "true";
                if (scroll_to_bottom) {
 //               selected-filters-slider-container
                    const target = document.getElementById('shopify-section-template--27296164577593__main');
                    if (target) {
                        const offset = 80;
                        const top = target.getBoundingClientRect().top + window.scrollY - offset;
                        window.scrollTo({ top, behavior: 'smooth' });
                    } else {
                        window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
                    }
                    return;
                }
                const url = card.dataset.url;
                if (url && url !== '#') {
                    window.location.href = url;
                    return;
                }
                const target = document.getElementById('shopify-section-template--27296164577593__main');
                if (target) {
                    const offset = 80;
                    const top = target.getBoundingClientRect().top + window.scrollY - offset;
                    window.scrollTo({ top, behavior: 'smooth' });
                }
            });
        });

        const onUnload = function(e) {
            if (e.detail.sectionId === sectionId) {
                clearInterval(timer);
                window.removeEventListener('resize', onResize);
                document.removeEventListener('shopify:section:unload', onUnload);
            }
        };
        document.addEventListener('shopify:section:unload', onUnload);
    });
}

if (document.readyState !== 'loading') {
    initHeroBanners();
} else {
    document.addEventListener("DOMContentLoaded", initHeroBanners);
}

document.addEventListener('shopify:section:load', function(e) {
    initHeroBanners();
});

(function() {
    var VIDEO_SRC = 'https://image.shoplc.com/Web/Custom_PDP/shopify-lgd-2026/v/Luxuriant-Black-vs-White-1%20(1).mp4';
    var DELAY_MS = 5000;
    var FADE_MS = 850;

    function injectVideo() {
        if (window.innerWidth > 767) return;
        var img = document.querySelector('.dynamic-mobile-video');
        if (!img || img.dataset.videoInjected) return;
        img.dataset.videoInjected = '1';

        var container = img.parentNode;
        var video = document.createElement('video');
        video.className = 'hero-bg-video';
        // Set as HTML attributes — required for Safari to honour muted + autoplay
        video.setAttribute('autoplay', '');
        video.setAttribute('muted', '');
        video.setAttribute('loop', '');
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', ''); // older iOS Safari
        // Mirror as JS properties for other browsers
        video.autoplay = true;
        video.muted = true;
        video.loop = true;
        video.playsInline = true;
        video.preload = 'auto';
        video.poster = img.currentSrc || img.src;
        video.src = VIDEO_SRC;

        // Insert invisible (opacity:0) so it can buffer under the poster
        container.appendChild(video);
        video.load();

        function reveal() {
            if (video.dataset.revealed) return;
            video.dataset.revealed = '1';

            video.play().catch(function() {});

            requestAnimationFrame(function() {
                video.classList.add('is-visible');
                img.classList.add('is-fading');
            });

            setTimeout(function() {
                if (img.parentNode) img.parentNode.removeChild(img);
                video.classList.add('is-settled');
            }, FADE_MS);
        }

        function revealWhenReady() {
            if (video.readyState >= 2) {
                reveal();
                return;
            }

            var done = false;
            function finish() {
                if (done) return;
                done = true;
                reveal();
            }

            video.addEventListener('loadeddata', finish, { once: true });
            video.addEventListener('canplay', finish, { once: true });
            // Don't leave the poster stuck if media events never fire
            setTimeout(finish, 2500);
        }

        setTimeout(revealWhenReady, DELAY_MS);
    }

    if (document.readyState !== 'loading') {
        injectVideo();
    } else {
        document.addEventListener('DOMContentLoaded', injectVideo);
    }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["live-tv-missed-products"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  var section = document.querySelector('.live-tv-missed-products');
  if (!section) return;

  // Tab switching
  section.querySelectorAll('.live-tv-missed-products__tab').forEach(function(tab){
    tab.addEventListener('click', function(){
      var blockId = tab.dataset.blockId;
      section.querySelectorAll('.live-tv-missed-products__tab').forEach(function(t){ t.classList.remove('live-tv-missed-products__tab--active'); t.setAttribute('aria-selected', 'false'); });
      tab.classList.add('live-tv-missed-products__tab--active');
      tab.setAttribute('aria-selected', 'true');

      section.querySelectorAll('.live-tv-missed-products__panel').forEach(function(panel){
        if (panel.dataset.blockId === blockId) {
          panel.classList.add('live-tv-missed-products__panel--active');
          
          // Force layout check for mobile
          const staticHosts = panel.querySelector('.live-tv-static-hosts');
          if (staticHosts) {
            if (panel.dataset.layoutType !== 'hosts_and_products') {
              staticHosts.style.display = 'none';
            } else {
              staticHosts.style.display = ''; // Restore default (flex)
            }
          }
        } else {
          panel.classList.remove('live-tv-missed-products__panel--active');
        }
      });
    });
  });

  // Keyboard support for the tablist (WCAG 2.1.1 / ARIA tabs pattern).
  var tvTabs = Array.prototype.slice.call(section.querySelectorAll('.live-tv-missed-products__tab'));
  tvTabs.forEach(function(tab, i){
    tab.addEventListener('keydown', function(e){
      var next = null;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = (i + 1) % tvTabs.length;
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = (i - 1 + tvTabs.length) % tvTabs.length;
      else if (e.key === 'Home') next = 0;
      else if (e.key === 'End') next = tvTabs.length - 1;
      if (next === null) return;
      e.preventDefault();
      tvTabs[next].click();
      tvTabs[next].focus();
    });
  });

  // Host click -> filter products
  section.addEventListener('click', function(e){
    var hostCard = e.target.closest('.live-tv-host-card');
    if (!hostCard) return;
    var hostTag = hostCard.dataset.hostTag;
    var panel = hostCard.closest('.live-tv-missed-products__panel');
    if (!panel) return;
    var productGrid = panel.querySelector('.live-tv-missed-products__products');
    if (!productGrid) return;

    // toggle active state
    hostCard.classList.toggle('live-tv-host-card--active');
    var active = hostCard.classList.contains('live-tv-host-card--active');

    // If activated: hide products that do not contain hostTag; if deactivated: show all
    productGrid.querySelectorAll('.live-tv-product-card').forEach(function(card){
      var tags = (card.dataset.hostTags || '').split(',');
      if (!active) {
        card.style.display = '';
      } else {
        if (tags.indexOf(hostTag) === -1) {
          card.style.display = 'none';
        } else {
          card.style.display = '';
        }
      }
    });
  });
});

// Static hosts left / right arrow scrolling
document.addEventListener('DOMContentLoaded', function () {
  const staticHosts = document.querySelector('.live-tv-static-hosts');
  if (!staticHosts) return;

  const viewport = staticHosts.querySelector('.live-tv-static-hosts__viewport');
  const leftArrow = staticHosts.querySelector('.live-tv-static-hosts__arrow--left');
  const rightArrow = staticHosts.querySelector('.live-tv-static-hosts__arrow--right');

  if (!viewport || !leftArrow || !rightArrow) return;

  const SCROLL_AMOUNT = 200; // approx one host card width

  leftArrow.addEventListener('click', function () {
    viewport.scrollBy({
      left: -SCROLL_AMOUNT,
      behavior: 'smooth'
    });
  });

  rightArrow.addEventListener('click', function () {
    viewport.scrollBy({
      left: SCROLL_AMOUNT,
      behavior: 'smooth'
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const section = document.querySelector('.live-tv-missed-products');
  if (!section) return;

  // Make static host filters keyboard-operable (Enter/Space) without changing visuals.
  section.querySelectorAll('.live-tv-static-hosts__item').forEach(function (item) {
    if (!item.hasAttribute('role')) item.setAttribute('role', 'button');
    if (!item.hasAttribute('tabindex')) item.setAttribute('tabindex', '0');
  });
  section.addEventListener('keydown', function (e) {
    const hostItem = e.target.closest('.live-tv-static-hosts__item');
    if (!hostItem) return;
    if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
      e.preventDefault();
      hostItem.click();
    }
  });

  // Handle static host click (triangle + active state)
  section.addEventListener('click', function (e) {
    const hostItem = e.target.closest('.live-tv-static-hosts__item');
    if (!hostItem) return;

    const hostsContainer = hostItem.closest('.live-tv-static-hosts__list');
    if (!hostsContainer) return;

    // 1. Remove active class from all hosts
    hostsContainer
      .querySelectorAll('.live-tv-static-hosts__item--active')
      .forEach(function (item) {
        item.classList.remove('live-tv-static-hosts__item--active');
      });

    // 2. Add active class to clicked host
    hostItem.classList.add('live-tv-static-hosts__item--active');

    // 3. Ensure triangle element exists (if not already in static HTML)
    if (!hostItem.querySelector('.live-tv-static-hosts__active-triangle')) {
      const triangle = document.createElement('div');
      triangle.className = 'live-tv-static-hosts__active-triangle';
      hostItem.appendChild(triangle);
    }
  });
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["live-tv-section-home-d"] && !Shopify.designMode) return;
  try {
    
  // Live TV video facade.
  // The video is this section's primary content, so it auto-starts (muted) as soon
  // as the block is in the DOM — muted is required for autoplay without a user
  // gesture. A user click loads it un-muted. The swap is idempotent and re-runs on
  // section re-render (theme editor) and bfcache restore, so it can never get stuck
  // showing only the poster (previously it was gated behind a one-shot
  // IntersectionObserver that could go stale / never fire below the fold).
  function loadLiveTvFacade(btn, muted) {
    if (!btn || btn.dataset.ytLoaded) return;
    var id = btn.getAttribute('data-video-id');
    if (!id) return;
    btn.dataset.ytLoaded = '1';

    var iframe = document.createElement('iframe');
    iframe.src =
      'https://www.youtube-nocookie.com/embed/' + id +
      '?autoplay=1&rel=0&playsinline=1' + (muted ? '&mute=1' : '');
    iframe.title = btn.getAttribute('aria-label') || 'Live TV';
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute(
      'allow',
      'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen'
    );
    iframe.allowFullscreen = true;

    var wrap = btn.parentNode;
    if (wrap) wrap.replaceChild(iframe, btn);
    return iframe;
  }

  // Immediate, un-muted play on user click (only fires while a facade is present).
  // Bound once at document level, even if this script runs again on section reload.
  if (!window.__liveTvFacadeClickBound) {
    window.__liveTvFacadeClickBound = true;
    document.addEventListener('click', function (event) {
      var btn = event.target.closest('.live-tv-content-block__video-facade[data-yt-facade]');
      if (!btn) return;
      var iframe = loadLiveTvFacade(btn, false);
      if (iframe) iframe.focus();
    });
  }

  // Auto-start every facade (muted) as soon as it is in the DOM. Idempotent: the
  // per-button data-yt-loaded guard makes re-runs a no-op once a player is swapped in.
  function startLiveTvFacades() {
    var facades = document.querySelectorAll('.live-tv-content-block__video-facade[data-yt-facade]');
    for (var i = 0; i < facades.length; i++) loadLiveTvFacade(facades[i], true);
  }

  if (document.readyState !== 'loading') {
    startLiveTvFacades();
  } else {
    document.addEventListener('DOMContentLoaded', startLiveTvFacades);
  }
  // Re-run when Shopify re-renders the section (theme editor) or on bfcache restore,
  // so a freshly-injected facade never sits stuck on its poster.
  document.addEventListener('shopify:section:load', startLiveTvFacades);
  window.addEventListener('pageshow', startLiveTvFacades);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-2"]) return;
  try {
    
  const url = new URL(window.location.href);

  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);

  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slc-clearance-slider"] && !Shopify.designMode) return;
  try {
    
(function () {
  function stepSize(track, view) {
    var first = track.children[0];
    var second = track.children[1];
    if (!first) return view.clientWidth;
    var a = first.getBoundingClientRect();
    var outer = a.width;
    if (second) outer = second.getBoundingClientRect().left - a.left;
    if (!outer || outer < 1) return view.clientWidth;
    var fit = Math.floor(view.clientWidth / outer);
    if (fit < 1) fit = 1;
    return fit * outer;
  }

  function init(root) {
    if (root.getAttribute('data-slc-ready')) return;
    root.setAttribute('data-slc-ready', '1');

    var view = root.querySelector('.slc-clearance__viewport');
    var track = root.querySelector('.slc-clearance__track');
    var prev = root.querySelector('.slc-clearance__nav--prev');
    var next = root.querySelector('.slc-clearance__nav--next');

    // No arrows = nothing to manage, so no listeners are added at all
    if (!view || !track || (!prev && !next)) return;

    var queued = false;
    var ro = null;

    function update() {
      queued = false;
      var max = view.scrollWidth - view.clientWidth;
      var scrollable = max > 2;
      if (prev) prev.hidden = !scrollable || view.scrollLeft <= 2;
      if (next) next.hidden = !scrollable || view.scrollLeft >= max - 2;
    }

    function queue() {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(update);
    }

    function onClick(e) {
      var btn = e.target.closest ? e.target.closest('.slc-clearance__nav') : null;
      if (!btn || !root.contains(btn)) return;
      view.scrollBy({ left: Number(btn.getAttribute('data-dir')) * stepSize(track, view), behavior: 'smooth' });
    }

    root.addEventListener('click', onClick);
    view.addEventListener('scroll', queue, { passive: true });

    if (window.ResizeObserver) {
      ro = new ResizeObserver(queue);
      ro.observe(view);
    } else {
      window.addEventListener('resize', queue);
    }

    root._slcDestroy = function () {
      root.removeEventListener('click', onClick);
      view.removeEventListener('scroll', queue);
      if (ro) ro.disconnect();
      else window.removeEventListener('resize', queue);
      root.removeAttribute('data-slc-ready');
    };

    update();
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('.slc-clearance');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });

  document.addEventListener('shopify:section:unload', function (e) {
    var roots = e.target.querySelectorAll('.slc-clearance');
    for (var i = 0; i < roots.length; i++) {
      if (roots[i]._slcDestroy) roots[i]._slcDestroy();
    }
  });

  document.addEventListener('shopify:block:select', function (e) {
    var card = e.target;
    if (card && card.classList && card.classList.contains('slc-clearance__card')) {
      card.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
